import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "control-group row pad-m" }
const _hoisted_4 = { class: "w-full row-end mtop-20" }

import { PropType, watch } from 'vue';
import { useEditor, EditorContent } from '@tiptap/vue-3';
import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text';
import { useI18n } from 'vue-i18n';
import esButton from '@/components/esButton.vue';
import { isValidJSON } from '@/utils/string-utils';

type Level = 1 | 2 | 3 | 4 | 5 | 6;

type Props = {
  modelValue?: string,
  editorStyle?: Record<string, string>;
  refEditor?: string;
  headingOption?: Level[];
  listOption?: boolean;
  textFormattingOption?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'esEditor',
  props: {
    modelValue: { default: '' },
    editorStyle: { default: () => ({ height: '150px'}) },
    refEditor: { default: 'ref' },
    headingOption: { default: () => [3, 4] },
    listOption: { type: Boolean, default: true },
    textFormattingOption: { type: Boolean, default: true }
  },
  emits: ['text-change'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const { t } = useI18n();

const editor = useEditor({
    content: isValidJSON(props.modelValue) ? JSON.parse(props.modelValue) : props.modelValue,
    extensions: [
        StarterKit.configure({
          heading: {
            levels: props.headingOption
          }
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
      ],
  })

const emit = __emit;

const saveData = () => {
  if (editor.value && editor.value.state.doc.textContent.trim().length > 0) {
    emit('text-change', JSON.stringify(editor.value.getJSON())); 
  } else {
    emit('text-change', null);
  }  
}

watch(() => props.modelValue, (newVal) => {
  if (isValidJSON(newVal)) {
    editor.value.commands.setContent(JSON.parse(newVal));
  } else {
      editor.value.commands.setContent(newVal);
  }
});


return (_ctx: any,_cache: any) => {
  const _component_es_button_icon = _resolveComponent("es-button-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(editor))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.headingOption)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.headingOption, (heading, index) => {
                  return (_openBlock(), _createBlock(esButton, {
                    key: heading,
                    label: _unref(t)(`settings.titleLabels.title${index + 1}`),
                    onClick: ($event: any) => (_unref(editor).chain().focus().toggleHeading({ level: heading }).run()),
                    "is-primary": false,
                    "is-linked": true,
                    styles: _unref(editor).isActive('heading', {level: heading}) ? 'img-primary h-14 w-14' : 'img-grey-dark h-14 w-14'
                  }, null, 8, ["label", "onClick", "styles"]))
                }), 128))
              : _createCommentVNode("", true),
            (_ctx.listOption)
              ? (_openBlock(), _createBlock(_component_es_button_icon, {
                  key: 1,
                  icon: "list_bullet",
                  folder: "shareIcons",
                  buttonStyles: "flex-square-24",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(editor).chain().focus().toggleBulletList().run())),
                  styles: _unref(editor).isActive('bulletList') ? 'img-primary h-14 w-14' : 'img-grey-dark h-14 w-14'
                }, null, 8, ["styles"]))
              : _createCommentVNode("", true),
            (_ctx.textFormattingOption)
              ? (_openBlock(), _createBlock(_component_es_button_icon, {
                  key: 2,
                  icon: "bold",
                  folder: "shareIcons",
                  buttonStyles: "flex-square-24",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(editor).chain().focus().toggleBold().run())),
                  styles: _unref(editor).isActive('bold') ? 'img-primary h-14 w-14' : 'img-grey-dark h-14 w-14'
                }, null, 8, ["styles"]))
              : _createCommentVNode("", true),
            (_ctx.textFormattingOption)
              ? (_openBlock(), _createBlock(_component_es_button_icon, {
                  key: 3,
                  icon: "italic",
                  folder: "shareIcons",
                  buttonStyles: "flex-square-24",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(editor).chain().focus().toggleItalic().run())),
                  styles: _unref(editor).isActive('italic') ? 'img-primary h-14 w-14' : 'img-grey-dark h-14 w-14'
                }, null, 8, ["styles"]))
              : _createCommentVNode("", true),
            (_ctx.textFormattingOption)
              ? (_openBlock(), _createBlock(_component_es_button_icon, {
                  key: 4,
                  icon: "underline",
                  folder: "shareIcons",
                  buttonStyles: "flex-square-24",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(editor).chain().focus().toggleUnderline().run())),
                  styles: _unref(editor).isActive('underline') ? 'img-primary h-14 w-14' : 'img-grey-dark h-14 w-14'
                }, null, 8, ["styles"]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_unref(EditorContent), {
            ref: _ctx.refEditor,
            editor: _unref(editor),
            style: _normalizeStyle(_ctx.editorStyle),
            class: "pad-m es-editor"
          }, null, 8, ["editor", "style"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(esButton, {
        label: _unref(t)('action.save'),
        "is-primary": true,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (saveData()))
      }, null, 8, ["label"])
    ])
  ]))
}
}

})